<!--
   Created by qing on 2020/2/27 3:46 下午
   Des:
-->
<template>
  <div>
    <van-cell class="ry-form__checkbox" v-if="isNormalStyle">
      <template slot="title">
        <span class="title">{{current.title}}</span>
        <span style="color: red" v-if="!isRead && current.required">*</span>
      </template>
      <template slot="label">

        <template v-if="current.fieldHint">
          <froalaView v-if="$store.getters.newRtf" v-model="current.fieldHint"></froalaView>
          <div
            v-else
            class="ql-editor"
            v-html="current.fieldHint">
          </div>
        </template>
        <div
          v-if="isRead">
          <template v-if="currentRow[current.dataId] && currentRow[current.dataId].length">
            <template v-if="current.showColor">
          <span
            v-for="opt in selectOpts"
            :key="opt.id"
            class="readonly-span"
            :style="{backgroundColor : opt.color}">
              {{opt.optionName}}
           </span>
            </template>

            <span v-else>
            {{selectOpts.map(opt => opt.optionName).join('、')}}
        </span>
          </template>
          <span v-else>
          暂无内容
      </span>
        </div>

        <template v-if="!isRead && current.showMode === SHOW_MODE__TILE">

          <el-checkbox-group
            v-if="current.showColor"
            ref="checkboxGroup"
            class="vertical-checkbox"
            :disabled="isReadOnly"
            @change="selectChange"
            v-model="selectValue">
            <el-checkbox
              class="checkbox-cus"
              v-for="(opt, idx) in currentRowOpts"
              :class="`checkbox-cus-${idx}`"
              :key="opt.id"
              :label="opt.id">
              {{opt.optionName}}
            </el-checkbox>
          </el-checkbox-group>

          <el-checkbox-group
            v-if="!current.showColor"
            ref="checkboxGroup"
            class="vertical-checkbox"
            :disabled="isReadOnly"
            @change="selectChange"
            v-model="selectValue">
            <el-checkbox
              v-for="(opt, idx) in currentRowOpts"
              :class="`checkbox-cus-${idx}`"
              :key="opt.id"
              :label="opt.id">
              {{opt.optionName}}
            </el-checkbox>
          </el-checkbox-group>
        </template>

        <div v-if="!isRead && current.showMode === SHOW_MODE__DROP_DOWN">
          <div class="ry-form__dropdown-input ry-form__checkbox-input" @click="openSelect">
            <div class="select-item">
              <template v-if="selectValue && selectValue.length">
              <span
                v-for="(item, idx) in selectValue"
                :style="{backgroundColor: current.showColor ? actionsMap[item].color || '#63B2EE' : '#fff', color: current.showColor ? '#fff' : '#000'}"
              >
                {{item}}
              </span>
              </template>

              <div v-else>
                {{current.fieldDes}}
              </div>
            </div>
            <van-icon
              v-if="currentRow[current.dataId] && currentRow[current.dataId].length"
              name="close"
              class="close-btn"
              @click.stop="clearData">
            </van-icon>
          </div>

          <div @click.stop.prevent>
            <van-action-sheet
              class="ry-form-action-sheet"
              v-model="show"
              :title="current.title"
              get-container="body"
              @select="onSelect"
              cancel-text="完成"
              :actions="actions">
            </van-action-sheet>
          </div>
        </div>

        <van-field
          v-if="!isRead && showOther"
          style="border: 1px solid #e6e6e6; padding: 5px;"
          v-model="otherValue"
          @change="otherValueChange"
        ></van-field>
      </template>
    </van-cell>

    <div v-else class="ry-form-item-compact ry-form__checkbox-compact">

      <van-field
        :label="current.title"
        :label-class="{'readonly-field-label': !isRead && isReadOnly}"
        :required="Boolean(!isRead && current.required)">
        <template #input>

          <div v-if="isRead">
            <template v-if="currentRow[current.dataId] && currentRow[current.dataId].length">
              <template v-if="current.showColor">
              <span
                v-for="opt in selectOpts"
                :key="opt.id"
                class="readonly-span"
                :style="{backgroundColor : opt.color}">
                {{opt.optionName}}
             </span>
              </template>

              <span v-else class="field-empty-tips">
              {{selectOpts.map(opt => opt.optionName).join('、')}}
            </span>
            </template>
            <span v-else class="field-empty-tips">
             暂无内容
          </span>
          </div>

          <template v-else>

            <template v-if="current.showMode === SHOW_MODE__TILE">

              <el-checkbox-group
                v-if="current.showColor"
                ref="checkboxGroup"
                :disabled="isReadOnly"
                @change="selectChange"
                v-model="selectValue">
                <el-checkbox
                  class="checkbox-cus"
                  v-for="(opt, idx) in currentRowOpts"
                  :class="`checkbox-cus-${idx}`"
                  :key="opt.id"
                  :label="opt.id">
                  {{opt.optionName}}
                </el-checkbox>
              </el-checkbox-group>

              <el-checkbox-group
                v-if="!current.showColor"
                ref="checkboxGroup"
                :disabled="isReadOnly"
                @change="selectChange"
                v-model="selectValue">
                <el-checkbox
                  v-for="(opt, idx) in currentRowOpts"
                  :class="`checkbox-cus-${idx}`"
                  :key="opt.id"
                  :label="opt.id">
                  {{opt.optionName}}
                </el-checkbox>
              </el-checkbox-group>
            </template>

            <template v-if="current.showMode === SHOW_MODE__DROP_DOWN">
              <div
                class="ry-form__dropdown-input ry-form__checkbox-input compact-container"
                style="border: none;; padding: 0"
                @click="openSelect">
                <div class="select-item" v-if="selectValue && selectValue.length">
                     <span
                       class="content"
                       :class="{'not-color' : !current.showColor}"
                       v-for="(item, idx) in selectValue"
                       :style="{backgroundColor: current.showColor ? actionsMap[item].color || '#63B2EE' : '#fff', color: current.showColor ? '#fff' : '#000'}"
                     >
                       {{item}}
                     </span>
                </div>
                <div v-else class="placeholder" style="margin-left: 0;">
                  {{current.fieldDes || isReadOnly ? '暂无内容' : '请选择'}}
                </div>
                <van-icon
                  v-if="currentRow[current.dataId] && currentRow[current.dataId].length && !isReadOnly"
                  name="close"
                  class="close-btn"
                  @click.stop="clearData">
                </van-icon>
              </div>

              <div @click.stop.prevent>
                <van-action-sheet
                  class="ry-form-action-sheet"
                  v-model="show"
                  :title="current.title"
                  get-container="body"
                  @select="onSelect"
                  cancel-text="完成"
                  :actions="actions">
                </van-action-sheet>
              </div>
            </template>

            <van-field
              v-if="showOther"
              style="border: 1px solid #e6e6e6; padding: 5px;"
              v-model="otherValue"
              @change="otherValueChange"
            ></van-field>
          </template>
        </template>
      </van-field>

    </div>

    <template v-if="['otherForm', 'current_table'].includes(current.optionsType)">
      <SelectOptionsPopup
        ref="selectOptionsPopup"
        :fetchType="current.optionsType"
        :multiple="true"
        :app-id="formSet.appId"
        :form-id="formSet.formId"
        :field-id="current.dataId"
        :query-field-id="current.relateFieldId"
        :filter-info="current.filterInfo"
        :table-field-id="current.tableFieldId"
        :advanced-filter="current.advancedFilter"
        :advanced-filter-info="current.advancedFilterInfo"
        :relate-data-source-type="current.relateDataSourceType"
        :relateFieldId="current.relateFieldId"
        :relateAppId="current.relateAppId"
        :relateFormId="current.relateFormId"
        :data="formSet.getValues()"
        :row-idx="index + 1"
        :sortList="current.sortList"
        :currentTableId="current.currentTableId"
        :dataFieldId="current.dataFieldId"
        @selectComplete="selectValueComplete"
      ></SelectOptionsPopup>
    </template>
    <template v-if="current.optionsType === 'openApi'">
      <SelectOptionsPopup
        ref="selectOptionsPopup"
        fetchType="openApi"
        :multiple="true"
        :app-id="formSet.appId"
        :form-id="formSet.formId"
        :field-id="current.dataId"
        :data="formSet.getValues()"
        :row-idx="index + 1"
        :requestType="current.requestType"
        :requestUrl="current.requestUrl"
        :methodType="current.methodType"
        :headerList="current.headerList"
        :paramType="current.paramType"
        :paramList="current.paramList"
        :requestBody="current.requestBody"
        :resultList="current.resultList"
        :updateList="current.updateList"
        :sortList="current.sortList"
        @selectComplete="selectValueComplete"
      ></SelectOptionsPopup>
    </template>
    <template v-if="current.optionsType === 'relateData'">
    </template>

    <RySelectPopup
      v-if="current.pluginConfig && current.pluginConfig.entryId"
      ref="rySelectPopup"
      :title="current.title"
      @selectComplete="selectComplete">
    </RySelectPopup>
  </div>

</template>

<script>
  import { current } from './mixin'
  import {SHOW_MODE__TILE, SHOW_MODE__DROP_DOWN, FORM_STATUS__FILL} from "../../types";
  import SelectOptionsPopup from "../component/SelectOptionsPopup";

  export default {
    mixins: [current],
    data() {
      return {
        SHOW_MODE__TILE,
        SHOW_MODE__DROP_DOWN,
        show: false,
        otherValue: '' // 本地记录用户输入的其他值，不提交服务器，但是在getValue时会做特殊处理
      }
    },
    components: {
      SelectOptionsPopup
    },
    computed: {
      // 获取options, 因为子表单选项类控件可能每一行不一样
      currentRowOpts() {
        const optionsMap = this.currentRow['optionsMap'] || {}
        return optionsMap[this.current.dataId] || this.current.options
      },
      content: {
        set(val) {
          this.currentRow[this.current.dataId] = val
        },
        get() {
          return this.currentRow[this.current.dataId] || []
        }
      },
      contentText() {

        if (this.current.optionsType === 'custom') {
          if (this.currentRow[this.current.dataId] && this.currentRow[this.current.dataId].length) {
            return this.currentRowOpts
              .filter(opt => this.currentRow[this.current.dataId].includes(opt.id))
              .map(opt => opt.optionName)
              .join('、')
          } else {
            return '暂无内容'
          }
        } else {
         return  this.currentRow[this.current.dataId].join('、')
        }
      },
      selectOpts() {
        const valueOpts = []
        this.currentRow[this.current.dataId].forEach(item => {
          if (!item.startsWith('其他_other_')) {

            const filterOpt = this.currentRowOpts.filter(opt => opt.id === item)[0]
            if (filterOpt) {
              if (item === '其他') {
                valueOpts.push({
                  id: `其他:${this.otherValue}`,
                  optionName: `其他:${this.otherValue}`,
                  color: filterOpt.color
                })
              } else {
                valueOpts.push(filterOpt)
              }
            } else {
              if (item === '其他') {
                valueOpts.push({
                  id: `其他:${this.otherValue}`,
                  optionName: `其他:${this.otherValue}`,
                  color: '#63B2EE'
                })
              } else {
                valueOpts.push({
                  id: item,
                  optionName: item,
                  color: '#63B2EE'
                })
              }
            }

          }
        })
        return valueOpts
        // return this.currentRowOpts.filter(opt => this.current.value.includes(opt.id))
      },
      actions () {

        const val = this.currentRow[this.current.dataId]
        if (this.currentRowOpts.length) {
          return this.currentRowOpts.map(item => {
            const result = { name: item.optionName }
            if (val.includes(item.optionName)) {
              result.color = item.color
            } else {
              result.color = 'transparent'
            }
            return result
          })
        } else {
          return [{ name: '暂无数据', disabled: true }]
        }

        // return this.currentRowOpts.map(item => {
        //   item.name = item.optionName
        //   if (!this.current.showColor) {
        //     item.color = "transparent"
        //   }
        //   return item
        // })
      },

      actionsMap () {
        const map = {}
        this.currentRowOpts.map(item => {
          map[item.id] = item
        })
        return map
      },
      selectValue: {
        set(val) {
          this.currentRow[this.current.dataId].splice(0, this.currentRow[this.current.dataId].length, ...val)
          if (this.currentRow[this.current.dataId].some(item => item === '其他') && this.otherValue) {
            this.currentRow[this.current.dataId].push(`其他_other_${this.otherValue}`)
          }
        },
        get() {
          const valueOpts = []
          this.currentRow[this.current.dataId].forEach(item => {
            if (!item.startsWith('其他_other_')) {
              valueOpts.push(item)
            }
          })
          return valueOpts
        }
      },
      showOther() {
        return this.currentRow[this.current.dataId].includes('其他') ||
          this.currentRow[this.current.dataId].some(item => item.startsWith('其他_other_'))
      }
    },

    created() {

      if (this.current.optionsType === 'custom' && this.showOther) {
        this.currentRow[this.current.dataId].forEach((item, idx) => {
          if (item.startsWith('其他_other_')) {
            this.otherValue = item.substring(9, item.length)
          }
        })
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.configOptColor()
      })
    },
    methods: {
      onSelect (opt) {
        let val = this.currentRow[this.current.dataId]
        if (!val) {
          val = []
        }

        if (val.includes(opt.name)) {
          val.splice(val.indexOf(opt.name), 1)
        } else {
          val.push(opt.name)
        }
        this.selectChange()
      },
      clearData() {
        this.currentRow[this.current.dataId].splice(0, this.currentRow[this.current.dataId].length)
        this.selectChange()
      },
      openSelect () {
        if (this.isReadOnly) return
        if (['otherForm', 'current_table'].includes(this.current.optionsType)) {
          if (this.$refs.selectOptionsPopup) {
            this.$refs.selectOptionsPopup.open(this.currentRow[this.current.dataId])
          }
        } else if (this.current.optionsType === 'openApi') {
          if (this.$refs.selectOptionsPopup) {
            this.$refs.selectOptionsPopup.open(this.currentRow[this.current.dataId])
          }
        } else if (this.current.optionsType === 'relateData') {
          if (this.$refs.selectOptionsPopup) {
            this.$refs.selectOptionsPopup.open(this.currentRow[this.current.dataId])
          }
        } else {
          this.show = true
        }
      },

      selectChange() {
        this.controlChange()
        this.submitData()
      },
      selectValueComplete(val) {
        this.currentRow[this.current.dataId].splice(0, this.currentRow[this.current.dataId].length, ...val)
        this.selectChange()
      },

      configOptColor() {
        if (this.$refs.checkboxGroup) {
          this.currentRowOpts.forEach((opt, idx) => {
            let ele = this.$refs.checkboxGroup.$el.querySelector(`.checkbox-cus-${idx} .el-checkbox__label`)
            if (this.current.showColor) {
              ele.style.backgroundColor = opt.color
            } else {
              ele.style.backgroundColor = '#fff'
            }
          })
        }
      },
      otherValueChange() {
        let index = -1
        this.currentRow[this.current.dataId].forEach((item, idx) => {
          if (item.startsWith('其他_other_')) {
            index = idx
          }
        })
        if (index === -1) {
          this.currentRow[this.current.dataId].push(`其他_other_${this.otherValue}`)
        } else {
          this.currentRow[this.current.dataId].splice(index, 1, `其他_other_${this.otherValue}`)
        }
        this.selectChange()
      }
    },
    watch: {

      type() {
        if (this.type === FORM_STATUS__FILL) {
          this.$nextTick(() => {
            this.configOptColor()
          })
        }
      }
    }
  }
</script>

<style lang="less">

  .ry-form__checkbox {
    .vertical-checkbox {
      display: flex;
      flex-direction: column;
    }

    .readonly-span {
      margin-left: 3px;
      padding: 2px 10px;
      border-radius: 20px;
      color: #fff;
      font-size: 14px;
    }

    .el-checkbox {
      padding: 6px 0;
      display: flex;
      align-items: center;
    }

    .checkbox-cus {

      .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #ffffff;
      }

      > .el-checkbox__label {
        background-color: #63B2EE;
        padding: 0 12px;
        margin-left: 10px;
        border-radius: 12px;
        font-weight: 400;
        color: #ffffff;
        min-height: 18px;
      }

    }

    .el-checkbox__label {
      word-break:normal;
      width:auto;
      white-space:pre-wrap;
      word-wrap : break-word ;
      overflow: hidden ;

    }

    .van-field__control--custom {
      display: inline-block;
    }
  }
</style>